(() => {
  const S = [["01","AL","Alabama"],["02","AK","Alaska"],["04","AZ","Arizona"],["05","AR","Arkansas"],["06","CA","California"],["08","CO","Colorado"],["09","CT","Connecticut"],["10","DE","Delaware"],["12","FL","Florida"],["13","GA","Georgia"],["15","HI","Hawaii"],["16","ID","Idaho"],["17","IL","Illinois"],["18","IN","Indiana"],["19","IA","Iowa"],["20","KS","Kansas"],["21","KY","Kentucky"],["22","LA","Louisiana"],["23","ME","Maine"],["24","MD","Maryland"],["25","MA","Massachusetts"],["26","MI","Michigan"],["27","MN","Minnesota"],["28","MS","Mississippi"],["29","MO","Missouri"],["30","MT","Montana"],["31","NE","Nebraska"],["32","NV","Nevada"],["33","NH","New Hampshire"],["34","NJ","New Jersey"],["35","NM","New Mexico"],["36","NY","New York"],["37","NC","North Carolina"],["38","ND","North Dakota"],["39","OH","Ohio"],["40","OK","Oklahoma"],["41","OR","Oregon"],["42","PA","Pennsylvania"],["44","RI","Rhode Island"],["45","SC","South Carolina"],["46","SD","South Dakota"],["47","TN","Tennessee"],["48","TX","Texas"],["49","UT","Utah"],["50","VT","Vermont"],["51","VA","Virginia"],["53","WA","Washington"],["54","WV","West Virginia"],["55","WI","Wisconsin"],["56","WY","Wyoming"]];
  const SMALL = ["VT","NH","MA","RI","CT","NJ","DE","MD"];
  const OFF = { FL:[28,8], MI:[18,26], LA:[-8,0], ME:[0,8], KY:[8,0], AK:[-10,10] };
  const TAGS = [["batt","10-year battery rule",/10[- ]years?|ten-year/i],["sale","Sale or transfer rule",/sale|transfer|sold or leased/i],["local","Local codes apply",/local level/i]];
  const NS = "http://www.w3.org/2000/svg";
  const el = (n, a = {}) => { const e = document.createElementNS(NS, n); for (const k in a) e.setAttribute(k, a[k]); return e; };

  class StateLegislation extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.byName = {}; this.byCode = {};
      JSON.parse(this.querySelector("#state-laws").textContent).forEach(r => {
        const d = document.createElement("div"); d.innerHTML = r.html;
        const ps = [...d.querySelectorAll("p")];
        const pick = re => ps.find(p => re.test(p.textContent.trim()));
        const smoke = pick(/^smoke/i), co = pick(/^carbon/i);
        this.byName[r.name.trim()] = { smoke: smoke ? smoke.outerHTML : "", co: co ? co.outerHTML : "", text: ps.map(p => p.textContent).join(" ") };
      });
      this.states = S.filter(s => this.byName[s[2]]).map(s => {
        const d = this.byName[s[2]];
        return { fips: s[0], code: s[1], name: s[2], smoke: d.smoke, co: d.co, tags: TAGS.filter(t => t[2].test(d.text)).map(t => t[0]) };
      });
      this.byCode = Object.fromEntries(this.states.map(s => [s.code, s]));
      this.sel = this.byCode.CA ? "CA" : this.states[0].code;
      this.hov = null; this.filter = null; this.paths = {}; this.labels = {};
      this.$ = q => this.querySelector(q);
      this.select = this.$("[data-select]");
      this.select.innerHTML = this.states.map(s => `<option value="${s.code}">${s.name}</option>`).join("");
      this.select.value = this.sel;
      this.select.addEventListener("change", () => this.pick(this.select.value));
      this.buildFilters();
      this.render(false);
      this.classList.add("is-ready");
      this.loadMap();
    }
    buildFilters() {
      const box = this.$("[data-filters]");
      TAGS.forEach(t => {
        const n = this.states.filter(s => s.tags.includes(t[0])).length;
        const b = document.createElement("button");
        b.type = "button"; b.dataset.filter = t[0]; b.setAttribute("aria-pressed", "false");
        b.innerHTML = `${t[1]}<i>${n}</i>`;
        box.appendChild(b);
      });
      box.addEventListener("click", e => {
        const b = e.target.closest("[data-filter]"); if (!b) return;
        this.filter = this.filter === b.dataset.filter ? null : b.dataset.filter;
        box.querySelectorAll("button").forEach(x => x.setAttribute("aria-pressed", String(x.dataset.filter === this.filter)));
        this.paint();
      });
    }
    buildSmalls() {
      const box = this.$("[data-smalls]");
      SMALL.filter(c => this.byCode[c]).forEach(c => {
        const b = document.createElement("button");
        b.type = "button"; b.dataset.code = c; b.textContent = c; b.setAttribute("aria-label", this.byCode[c].name);
        box.appendChild(b); this.paths[c + "-btn"] = b;
      });
    }
    async loadMap() {
      try {
        const topo = await (await fetch(this.dataset.mapUrl)).json();
        const [sx, sy] = topo.transform.scale, [tx, ty] = topo.transform.translate;
        const arcs = topo.arcs.map(a => { let x = 0, y = 0; return a.map(([dx, dy]) => { x += dx; y += dy; return [x * sx + tx, y * sy + ty]; }); });
        const ring = idx => { let pts = []; idx.forEach((i, k) => { const a = i < 0 ? arcs[~i].slice().reverse() : arcs[i]; pts = pts.concat(k ? a.slice(1) : a); }); return pts; };
        const svg = this.$("[data-svg]"), gP = el("g"), gL = el("g");
        svg.append(gP, gL); this.gP = gP;
        const byFips = Object.fromEntries(this.states.map(s => [s.fips, s]));
        topo.objects.states.geometries.forEach(g => {
          const st = byFips[String(g.id).padStart(2, "0")]; if (!st) return;
          const polys = g.type === "Polygon" ? [g.arcs] : g.arcs;
          let d = "", best = null;
          polys.forEach(pl => {
            const rings = pl.map(ring);
            d += rings.map(r => "M" + r.map(p => p[0].toFixed(1) + "," + p[1].toFixed(1)).join("L") + "Z").join("");
            let x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
            rings[0].forEach(p => { x0 = Math.min(x0, p[0]); y0 = Math.min(y0, p[1]); x1 = Math.max(x1, p[0]); y1 = Math.max(y1, p[1]); });
            const a = (x1 - x0) * (y1 - y0);
            if (!best || a > best.a) best = { a, x: (x0 + x1) / 2, y: (y0 + y1) / 2, w: x1 - x0, h: y1 - y0 };
          });
          const p = el("path", { d, "data-code": st.code, role: "button", tabindex: "0", "aria-label": st.name });
          gP.appendChild(p); this.paths[st.code] = p;
          if (best.w > 34 && best.h > 26 && !SMALL.includes(st.code)) {
            const o = OFF[st.code] || [0, 0];
            const t = el("text", { x: best.x + o[0], y: best.y + o[1] }); t.textContent = st.code;
            gL.appendChild(t); this.labels[st.code] = t;
          }
        });
        this.$("[data-map]").hidden = false;
        const map = this.$("[data-map]");
        const hoverOK = () => matchMedia("(hover:hover)").matches;
        const code = e => { const t = e.target.closest("[data-code]"); return t && t.dataset.code; };
        map.addEventListener("click", e => { const c = code(e); if (c) this.pick(c); });
        map.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { const c = code(e); if (c) { e.preventDefault(); this.pick(c); } } });
        map.addEventListener("mouseover", e => { const c = code(e); if (c && hoverOK() && c !== this.hov) { this.hov = c; this.render(true); } });
        map.addEventListener("focusin", e => { const c = code(e); if (c && c !== this.hov) { this.hov = c; this.render(true); } });
        const leave = () => { if (this.hov) { this.hov = null; this.render(true); } };
        map.addEventListener("mouseleave", leave); map.addEventListener("focusout", leave);
        this.paint();
      } catch (e) { /* the dropdown keeps working without the map */ }
    }
    pick(c) { this.sel = c; this.hov = null; this.select.value = c; this.render(true); }
    paint() {
      const a = this.hov || this.sel, f = this.filter;
      this.states.forEach(s => {
        const on = !f || s.tags.includes(f), isA = s.code === a;
        [this.paths[s.code], this.paths[s.code + "-btn"]].forEach(n => {
          if (!n) return;
          n.classList.toggle("is-active", isA); n.classList.toggle("is-match", !!f && on); n.classList.toggle("is-dim", !on);
          n.setAttribute("aria-pressed", String(s.code === this.sel));
        });
        if (this.labels[s.code]) this.labels[s.code].classList.toggle("is-active", isA);
      });
      const p = this.paths[a]; if (p && this.gP && this.gP.lastChild !== p) this.gP.appendChild(p);
    }
    render(animate) {
      const s = this.byCode[this.hov || this.sel], card = this.$("[data-card]");
      const fill = () => {
        this.$("[data-name]").textContent = s.name; this.$("[data-abbr]").textContent = s.code;
        this.$("[data-smoke]").innerHTML = s.smoke; this.$("[data-co]").innerHTML = s.co;
        this.$("[data-tags]").innerHTML = (s.tags.length ? s.tags.map(t => TAGS.find(x => x[0] === t)[1]) : ["Standard requirements"]).map(t => `<span>${t}</span>`).join("");
        card.classList.remove("is-out");
      };
      this.paint();
      if (!animate || this.shown === s.code) { this.shown = s.code; fill(); return; }
      this.shown = s.code; card.classList.add("is-out");
      clearTimeout(this.t); this.t = setTimeout(fill, 40);
    }
  }
  customElements.define("state-legislation", StateLegislation);
})();
